import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ChapterHeading = ({ number, eyebrow, title, copy }) => (
  <Reveal>
    <div className="flex items-center gap-4">
      <span className="font-mono-alt text-xs tracking-[0.3em] text-terracotta">{number}</span>
      <span aria-hidden className="h-px w-12 bg-terracotta/50" />
      <span className="font-mono-alt text-[11px] uppercase tracking-[0.3em] text-sage-dark">{eyebrow}</span>
    </div>
    <h2 className="mt-5 font-display text-3xl font-medium tracking-tight text-forest sm:text-5xl">{title}</h2>
    {copy && <p className="mt-4 max-w-xl text-base leading-relaxed text-muted-ink sm:text-lg">{copy}</p>}
  </Reveal>
);
